import { getCookie, setCookie } from '@/utils/functions';
import { useState, useEffect } from 'react';

// Utility to check if the user is eligible based on sign-up date
function isEligibleForModal(createdAt: string): boolean {
  const signupDate = new Date(createdAt);
  const cutoffDate = new Date('2024-10-11T23:59:59Z'); // 11th October end of the day
  return signupDate <= cutoffDate;
}

interface UseModal {
  isModalShown: boolean;
  handleModalClose: () => void;
}

// Custom Hook
function useUpdatedTermsModal(createdAt: string): UseModal {
  const [isModalShown, setIsModalShown] = useState<boolean>(false);

  useEffect(() => {
    const userEligible = isEligibleForModal(createdAt);
    const modalClosed = getCookie('modalClosed');

    if (userEligible && !modalClosed) {
      setIsModalShown(true);
    }
  }, [createdAt]);

  const handleModalClose = (): void => {
    setCookie('modalClosed', 'true', 365); // Store for 1 year
    setIsModalShown(false);
  };

  return { isModalShown, handleModalClose };
}

export default useUpdatedTermsModal;
